import TagsFormContainer from './TagsFormContainer';

export default TagsFormContainer;
